import CardPage3 from "./cardPage";
import Title3 from "./title3";

export default function Page3(){
    return(
        <>
        <Title3/>
        <CardPage3/>
        </>
    )
}